import { useRef, useEffect } from 'react';
import { useWindowSize } from 'usehooks-ts';

export const useTooltipPosition = () => {
	const { width = 0 } = useWindowSize({ debounceDelay: 250 });
	const textRef = useRef<HTMLParagraphElement>(null);
	const wrapperRef = useRef<HTMLDivElement>(null);

	const adjustPosition = () => {
		if (textRef.current && wrapperRef.current) {
			const textRect = textRef.current.getBoundingClientRect();
			const wrapperRect = wrapperRef.current.getBoundingClientRect();
			const positionMargin = 20;

			const isRightCollision = width - textRect.width - positionMargin < wrapperRect.left;
			const isLeftCollision = wrapperRect.left < textRect.width;

			if (isRightCollision && !isLeftCollision) {
				textRef.current.style.left = `-${textRect.width - positionMargin}px`;
			} else if (isRightCollision && isLeftCollision) {
				textRef.current.style.left = `-${wrapperRect.left - positionMargin}px`;
			} else {
				textRef.current.style.left = '0';
			}
		}
	};

	useEffect(() => {
		adjustPosition();
	}, [width]);

	return { textRef, wrapperRef };
};
